<ng-container *ngIf="!assets.length">
  <div class="flex flex-col items-center justify-center h-full">
    <div class="flex flex-col items-center justify-center">
      <p class="text-xl">No assets selected</p>
    </div>
  </div>
</ng-container>

<form [formGroup]="selectRelationsForm">
  <div formArrayName="assets" *ngFor="let assetCtrl of formArray.controls; let i = index">
    <div [formGroupName]="i" class="grid grid-cols-2 xl:grid-cols-3 gap-4 mb-4">
      <div class="asset-card">
        <ng-container *ngTemplateOutlet="assetTemplate; context: { $implicit: assets[i] }"></ng-container>
        <p class="overflow-hidden overflow-ellipsis whitespace-nowrap w-full">{{ assets[i].name }}</p>
      </div>
      <div class="select-relation flex flex-col">
        <div class="flex items-center gap-2">
          <sp-mat-select-search
            class="w-full"
            formControlName="relationTypes"
            [dataSource]="relationTypes"
            [config]="{
              search: true,
              required: assetCtrl.get('relationTypes')?.invalid && assetCtrl.get('relationTypes')?.touched,
              requiredText: textIsRequired,
              multiple: true,
              enableSecondPartLabel: true,
            }"
            [placeholder]="'Select relation:'"
            [attrDataTestId]="'asset-relations-select_relations'"
            (removeChip)="removeChip($event, i)"
          ></sp-mat-select-search>
          <button mat-icon-button type="button" (click)="deleteAsset(i)" matTooltip="Delete asset">
            <mat-icon>
              <span class="material-icons-outlined">delete_outline</span>
            </mat-icon>
          </button>
        </div>
        <div class="text-[#f0415f] text-xs mt-1" *ngIf="assetCtrl.get('relationTypes')?.invalid && formStateChange">{{ textIsRequired }}</div>
      </div>
    </div>
  </div>
</form>

<ng-template #assetTemplate let-asset>
  <div class="h-[65px] w-20 mr-4 bg-white cursor-pointer relative">
    <div class="asset-image-box h-full w-full flex items-center overflow-hidden">
      <img *ngIf="asset.imageUrl || asset.previewUrl" class="object-contain h-full m-auto" [src]="asset.imageUrl || asset.previewUrl | imageLoading | async" alt="{{ asset.name }}" />
      <div *ngIf="!asset.imageUrl && !asset.previewUrl" class="h-full w-full flex justify-center items-center">
        <span class="text-sm font-bold text-center" i18n>Preview Not Available</span>
      </div>
    </div>
  </div>
</ng-template>
